import Router from "vue-router"
import routes from "./routes"

export default Vue => {
  Vue.use(Router)

  const routeConfig = routes(Vue)
  return new Router({
    mode: "history",
    routes: routeConfig
  })
}
